<template>
  <ul class="lv1 text-end">
    <li v-for="(item, i) in menu" :key="item.title" class="h3-style">
      <template v-if="item.path.search('#') > -1">
        <a
          :href="item.path"
          v-smooth-scroll="{ duration: 0, offset: -170 }"
          :class="{ 'router-link-exact-active': item.title === section }"
          v-html="item.title"
        ></a>
      </template>
      <template v-else>
        <router-link
          :to="item.path + groupIdPath"
          :class="{
            'router-link-exact-active':
              i === 0 && $route.name.includes('CampList'),
          }"
          v-html="item.title"
        ></router-link>
        <ul class="me-0" v-if="item.submenu.length > 0">
          <li v-for="(sub, j) in item.submenu" :key="j" class="submenu">
            <router-link
              :to="sub.path + groupIdPath"
              v-html="sub.title"
            ></router-link>
          </li>
        </ul>
      </template>
    </li>
    <template v-if="$route.name == 'Records' || $route.name == 'OnlineCourses'">
      <li class="h3-style">
        <a
          href="//www.animlab.yuntech.edu.tw/talentpool/gallery"
          target="_blank"
          >線上藝廊</a
        >
      </li>
      <li class="h3-style">
        <a href="//www.animlab.yuntech.edu.tw/talentpool/pool" target="_blank"
          >菁培學員</a
        >
      </li>
    </template>

    <!-- <template v-if="$route.name == 'Home'">
      <li class="h3-style apply">
        <router-link to="/apply-login">線上報名</router-link>
      </li>
    </template> -->
  </ul>
</template>

<script>
export default {
  name: 'SideMenu',
  props: {
    menu: { type: Array, required: true },
    section: { type: String, required: false },
  },
  data() {
    return {
      activeItem: -1,
      lastScrollPosition: 0,
    };
  },
  computed: {
    groupIdPath() {
      return (Object.prototype.hasOwnProperty.call(this.$route.params, 'groupId')) ? `/${this.$route.params.groupId}` : '';
    },
  },
  mounted() {
    // window.addEventListener('scroll', this.onScroll);
    // console.log(this.$route.name);
  },
  // beforeUnmount() {
  //   window.removeEventListener('scroll', this.onScroll);
  // },
  // methods: {
  //   onScroll() {
  //     // Get the current scroll position
  //     const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  //     // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
  //     if (currentScrollPosition < 0) {
  //       return;
  //     }
  //     // Here we determine whether we need to show or hide the navbar
  //     this.showNavbar = currentScrollPosition < this.lastScrollPosition;
  //     // Set the current scroll position as the last scroll position
  //     this.lastScrollPosition = currentScrollPosition;
  //   },
  // },
};
</script>

<style lang="stylus" scoped>
ul.lv1
  margin-right: 72px;

  > li
    margin-bottom: 16px;

li
  list-style: none;

  li.submenu
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;

  a
    text-decoration: none;
    color: $monoc4;
    opacity: 0.2;

    &.router-link-exact-active, &:hover
      opacity: 1;

.router-link-exact-active
  user-select: none;
  pointer-events: none;

.submenu > .router-link-exact-active::before
  content: '•';
  margin-right: 4px;
  font-weight: 700;

@media screen and (max-width: 1400px)
  ul.lv1
    margin-right: 36px;

@media screen and (max-width: 1200px)
  ul.lv1
    margin-right: 24px;

    li.submenu
      font-size: 16px;

.lv1 > .apply
  margin-top: 30px;

  a
    background-color: $monoc4;
    color: $monoc1;
    font-size: 0.9em;
    border-radius: 20px;
    padding: 2px 16px;
    opacity: 1;
</style>
